const emailJS = {
   serviceID: 'gmail',
   templateID: 'template_nn2ybvu',
   userID: 'eMwiPBa8CXg0Kun0s'
};

export {
   emailJS
};